

const MainContent = () => {
    return (
       <div ClasssName='MC'>
           <h1 style={{color:'#81C4FF' , fontSize:'60px'}}>Featured Builds</h1>
           <br></br>
           <div className='MCBuildBox' >
           <h1 style={{justifyContent:'center'}}>Monte Carlo E92</h1>
           <p className='Content-writing'>
             This Monte Carlo Blue Individual BMW E92 M3 is 
             certainly a contender for the award of the best 
             looking M3. Featuring one of the most beautiful exterior
             finishes available for the M3 – Monte Carlo Blue – this
             M3 comes with a variety of clean and simple aero parts. This E92 
             M3 comes with a nice power upgrade as well, yielding big gains 
             and improved overall performance. The handling and safety of 
             the M3 have also been further improved thanks to a new suspension
             and a performance brake system.  After you lift the aluminum hood, 
             you’ll be greeted with a beautifully painted ESS VT2-625 supercharger
             system. This gives the BMW E92 M3 for an increase in horsepower
             and torque, yielding not so much faster acceleration but overall 
             driving dynamics, cornering speed and overall performance of the
             vehicle.<br></br><br></br>
             Vanja Kljaicbr<br></br>
              September 7, 2015
             <div className='buildimgcontainer' >
             <img src='build1.1.jpg' alt='pic1'/>
            <img src='buildpic1.2.jpg' alt='pic2'/>
             <img src='buildpic1.3.jpg' alt='pic3'/>
                     </div>
                 </p><br></br>
                 </div>

                 <div className='MCBuildBox'>
                 <h1 style={{justifyContent:'center', color:'#e7222e'}}>Driftworks E30 M3 S65 V8 Race Car Build</h1>
           <p className='Content-writing'>
           Phil Morrison is the owner of the English company Driftworks, a 
           business that started out as a group of friends that helped 
           introduce the sport of drifting to the UK and eventually turned 
           Driftworks into a very successful business that manufactures and 
           sells millions in drifting and track performance products.<br></br>
           <br></br>
           His latest build is an E30 M3 race car and it does not disappoint, 
           from what Phil knows the car seems to have started its life as some 
           form of race shell for Prodrive but he's not too sure, he purchased 
           it off of someone who had fitted it with and E92 S65 4.0 V8, Phil 
           who is a bit of a perfectionist has turned this amazing track car 
           into a piece of art, while his main goal for the car is to be very 
           very fast around the Nurburgring.  You can follow the project on the 
           Driftworks Youtube Channel.
                     <br></br><br></br>
                     @Philmorrisond2<br></br>
                    October 6, 2017
                     <div className='buildimgcontainer'>
                    <img src='DWbmw1.1.jpg' alt='pic1'/>
                    <img src='DWbmw1.2.jpg' alt='pic2'/>
                    <img src='DWbmw1.3.jpg' alt='pic3'/>
                     </div>
                 </p>
                </div>

                <div className='MCBuildBox'>
                 <h1 style={{justifyContent:'center', color:'#16588e'}}>Wide-Body BMW M3 Coupe E36</h1>
           <p className='Content-writing'>
           “I had this wide-body turbo vision immediately when I saw it for sale. 
           Me and my girlfriend went to see it and she told me not to buy 
           because it was in terrible condition and she said no one can make 
           it look and run like a car again. That was the moment when I decided 
           to buy it and show what can I do,” he grins and he’s certainly done 
           that.<br></br>
           <br></br>
           No part of this project was a small area to work on because of the state that the car 
           was in when Joni bought it, but it’s fair to say that the exterior was 
           quite possibly the largest undertaking, especially when you take into 
           account the transformation that this M3 has undergone.  The finishing touch 
           is the trims, all of which have been changed for fresh ones and they’ve been
            painted with Joni’s own blend of black and textured matt finish.
                     <br></br><br></br>
                     Joni Pursiainen<br></br>
                     December 6, 2019
                     <div className='buildimgcontainer'>
                    <img src='e36M31.1.jpg' alt='pic1'/>
                    <img src='e36M31.2.jpg' alt='pic2'/>
                    <img src='e36M31.3.jpg' alt='pic3'/>
                     </div>
                 </p>
                </div>
           
           
       </div>
        
    )
}

export default MainContent
